import React from 'react';
import { SettingsPage as NewSettingsPage } from '../modules/settings/pages/SettingsPage';

export const SettingsPage: React.FC = () => {
  return <NewSettingsPage />;
};
